import { intl } from '../../utils/intl';
const t = (id) => intl.formatMessage({ id });

const id360LocationOptions = [
  { label: 'Front Exterior', value: 'Front Exterior' },
  { label: 'Rear Exterior', value: 'Rear Exterior' },
  { label: 'Left Exterior', value: 'Left Exterior' },
  { label: 'Right Exterior', value: 'Right Exterior' },
  { label: 'Electrical Room', value: 'Electrical Room' },
  { label: 'Meter Room', value: 'Meter Room' },
  { label: 'Riser Room', value: 'Riser Room' },
  { label: 'Sprinkler Room', value: 'Sprinkler Room' },
  { label: 'Utility Room', value: 'Utility Room' },
  { label: 'Restroom', value: 'Restroom' },
  { label: 'Restroom Ceiling', value: 'Restroom Ceiling' },
  { label: 'Ceiling', value: 'Ceiling' },
  { label: 'Roof', value: 'Roof' },
  { label: 'Rear Wall', value: 'Rear Wall' },
  { label: 'Mezzanine', value: 'Mezzanine' },
  { label: 'Break Room', value: 'Break Room' },
  { label: 'Closet', value: 'Closet' },
  { label: 'Fitting Room', value: 'Fitting Room' },
  { label: 'Hallway', value: 'Hallway' },
  { label: 'Kitchen', value: 'Kitchen' },
  { label: 'Kitchenette', value: 'Kitchenette' },
  { label: 'Maintenance Room', value: 'Maintenance Room' },
  { label: 'Mechanical Room', value: 'Mechanical Room' },
  { label: 'Open Space', value: 'Open Space' },
  { label: 'Patio', value: 'Patio' },
  { label: 'Private Room', value: 'Private Room' },
  { label: 'Office', value: 'Office' },
  { label: 'Recieving', value: 'Recieving' },
  { label: 'Reception', value: 'Reception' },
  { label: 'Sauna', value: 'Sauna' },
  { label: 'Server Room', value: 'Server Room' },
  { label: 'Shower Room', value: 'Shower Room' },
  { label: 'Stairway', value: 'Stairway' },
  { label: 'Storage Room', value: 'Storage Room' },
  { label: 'Vault', value: 'Vault' },
  { label: 'Vestibule', value: 'Vestibule' },
  { label: 'Wash Room', value: 'Wash Room' },
  { label: 'Warehouse', value: 'Warehouse' },
  { label: 'Inaccessible', value: 'Inaccessible' },
  { label: 'Other', value: 'Other' },
  { label: 'NA', value: 'NA' }
]

const rpmLocationOptions = [
  { label: 'Front Exterior', value: 'Front Exterior' },
  { label: 'Rear Exterior', value: 'Rear Exterior' },
  { label: 'Left Exterior', value: 'Left Exterior' },
  { label: 'Right Exterior', value: 'Right Exterior' },
  { label: 'Electrical Room', value: 'Electrical Room' },
  { label: 'Riser Room', value: 'Riser Room' },
  { label: 'Meter Room', value: 'Meter Room' },
  { label: 'Sprinkler Room', value: 'Sprinkler Room' },
  { label: 'Utility Room', value: 'Utility Room' },
  { label: 'East Side of Property', value: 'East Side of Property' },
  { label: 'West Side of Property', value: 'West Side of Property' },
  { label: 'North Side of Property', value: 'North Side of Property' },
  { label: 'South Side of Property', value: 'South Side of Property' },
  { label: 'Northwest Corner', value: 'Northwest Corner' },
  { label: 'Southwest Corner', value: 'Southwest Corner' },
  { label: 'Northeast Corner', value: 'Northeast Corner' },
  { label: 'Southeast Corner', value: 'Southeast Corner' },
  { label: 'Pavilion', value: 'Pavilion' },
  { label: 'Alleyway', value: 'Alleyway' },
  { label: 'Grassy Area', value: 'Grassy Area' },
  { label: 'Meter Vault', value: 'Meter Vault' },
  { label: 'Hotbox', value: 'Hotbox' },
  { label: 'Parking Lot', value: 'Parking Lot' },
  { label: 'Sidewalk', value: 'Sidewalk' },
  { label: 'Street', value: 'Street' },
  { label: 'Parking Garage', value: 'Parking Garage' },
  { label: 'Roof', value: 'Roof' },
  { label: 'Basement', value: 'Basement' },
  { label: 'Ceiling', value: 'Ceiling' },
  { label: 'Restroom', value: 'Restroom' },
  { label: 'Restroom Ceiling', value: 'Restroom Ceiling' },
  { label: 'Closet', value: 'Closet' },
  { label: 'Kitchen', value: 'Kitchen' },
  { label: 'Office', value: 'Office' },
  { label: 'Warehouse', value: 'Warehouse' },
  { label: 'Maintenance Room', value: 'Maintenance Room' },
  { label: 'Mechanical Room', value: 'Mechanical Room' },
  { label: 'Inside the Space', value: 'Inside the Space' },
  { label: 'Inside Next Door Space', value: 'Inside Next Door Space' },
  { label: 'Recieving', value: 'Recieving' },
  { label: 'Inaccessible', value: 'Inaccessible' },
  { label: 'Other', value: 'Other' },
  { label: 'NA', value: 'NA' }
]


export default {
  basic_info: {
    outer_unit_corner_to_outer_block_corner: {
      label: t('assetSchema.headers.outer_unit_corner_to_outer_block_corner'),
      left: {
        label: t('assetSchema.left'),
        placeholder: `13' 2"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      right: {
        label: t('assetSchema.right'),
        placeholder: `10' 11"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    height_from_floor_to_bottom_of_girder_kite: {
      label: t('assetSchema.headers.height_from_floor_to_bottom_of_girder_kite'),
      left_front: {
        label: t('assetSchema.left_front'),
        placeholder: `15' 6"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      right_rear: {
        label: t('assetSchema.right_rear'),
        placeholder: `13' 7"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    thermostat_count: {
      label: t('assetSchema.thermostat_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    thermostat_location: {
      label: t('assetSchema.thermostat_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    phone_board_count: {
      label: t('assetSchema.phone_board_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    phone_board_location: {
      label: t('assetSchema.phone_board_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    cleanout_count: {
      label: t('assetSchema.cleanout_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    cleanout_location: {
      label: t('assetSchema.cleanout_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    pad_mounted_transformer_count: {
      label: t('assetSchema.pad_mounted_transformer_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    pad_mounted_transformer_location: {
      label: t('assetSchema.pad_mounted_transformer_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: rpmLocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    electric_meter_distance: {
      label: t('assetSchema.electric_meter_distance'),
      placeholder: '23',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    gas_meter_distance: {
      label: t('assetSchema.gas_meter_distance'),
      placeholder: '24',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    water_meter_distance: {
      label: t('assetSchema.water_meter_distance'),
      placeholder: '32',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    transformer_distance: {
      label: t('assetSchema.transformer_distance'),
      placeholder: '33',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    sewer_cleanout_distance: {
      label: t('assetSchema.sewer_cleanout_distance'),
      placeholder: '42',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    utility_room_distance: {
      label: t('assetSchema.utility_room_distance'),
      placeholder: '47',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    DMARC_distance: {
      label: t('assetSchema.DMARC_distance'),
      placeholder: '46',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    mop_sink_location: {
      label: t('assetSchema.mop_sink_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    mop_sink_count: {
      label: t('assetSchema.mop_sink_count'),
      placeholder: '0',
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    sanitary_sewer_location: {
      label: t('assetSchema.sanitary_sewer_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    sanitary_sewer_count: {
      label: t('assetSchema.sanitary_sewer_count'),
      placeholder: '0',
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    }, 
    are_demising_walls_full_height: {
      label: t('assetSchema.are_demising_walls_full_height'),
      placeholder: '',
      type: 'boolean',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      },
      width: '100%'
    },
    are_interior_walls_full_height: {
      label: t('assetSchema.are_interior_walls_full_height'),
      placeholder: '',
      type: 'boolean',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      },
      width: '100%'
    },
    property_features: {
      label: t('assetSchema.headers.property_features'),
      power: {
        label: t('assetSchema.power.label'),
        type: 'text',
        placeholder: t('assetSchema.power.label'),
        enabled: false,
        visible: false
      },
      storefront_width: {
        label: t('assetSchema.headers.storefront_width'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false
      },
      storefront_features: {
        label: t('assetSchema.headers.storefront_features'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.walkway'), value: 'Walkway' },
          { label: t('assetSchema.trash_cans'), value: 'Trash Cans' },
          { label: t('assetSchema.ash_trays'), value: 'Ash Trays' },
          { label: t('assetSchema.handicap_parking'), value: 'Handicap Parking' },
          { label: t('assetSchema.columns'), value: 'Column(s)' },
          { label: t('assetSchema.crosswalk'), value: 'Crosswalk' },
          { label: t('assetSchema.canopy'), value: 'Canopy' },
          { label: t('assetSchema.trees'), value: 'Tree(s)' },
          { label: t('assetSchema.bushes'), value: 'Bushes' },
          { label: t('assetSchema.steps'), value: 'Steps' },
          { label: t('assetSchema.ramps'), value: 'Ramps' },
          { label: t('assetSchema.handicap_signs'), value: 'Handicap Signs' },
          { label: t('assetSchema.stop_signs'), value: 'Stop Signs' },
          { label: t('assetSchema.tenant_signs'), value: 'Tenant Signs' },
          { label: t('assetSchema.other_affixed_signage'), value: 'Other Affixed Signage' },
          { label: t('assetSchema.railings'), value: 'Railing' },
          { label: t('assetSchema.bollards'), value: 'Bollards' },
          { label: t('assetSchema.grass'), value: 'Grass' },
          { label: t('assetSchema.garden'), value: 'Garden' },
          { label: t('assetSchema.fire_hydrant'), value: 'Fire Hydrant' },
          { label: t('assetSchema.planters'), value: 'Planters' },
          { label: t('assetSchema.dirt'), value: 'Dirt' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.not_available'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        required: false
      },
      damaged_stained_missing_acoustical_tiles: {
        label: t('assetSchema.headers.damaged_stained_missing_acoustical_tiles'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false
      },
      ceiling_types: {
        label: t('assetSchema.headers.ceiling_types'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.open_ceiling'), value: 'Open Ceiling' },
          { label: t('assetSchema.acoustic_tile'), value: 'Acoustic Tile' },
          { label: t('assetSchema.drywall'), value: 'Drywall' },
          { label: t('assetSchema.wood'), value: 'Wood' },
          { label: t('assetSchema.metal'), value: 'Metal' },
          { label: t('assetSchema.concrete_type'), value: 'Concrete' },
          { label: t('assetSchema.stucco'), value: 'Stucco' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.inconclusive'), value: 'Inconclusive' },
          { label: t('assetSchema.inaccessible'), value: 'Inaccessible' }
        ],
        enabled: false,
        required: false,
        visible: false
      },
      wall_types: {
        label: t('assetSchema.headers.wall_types'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.drywall'), value: 'Drywall' },
          { label: t('assetSchema.glass'), value: 'Glass' },
          { label: t('assetSchema.wood'), value: 'Wood' },
          { label: t('assetSchema.stone'), value: 'Stone' },
          { label: t('assetSchema.concrete_type'), value: 'Concrete' },
          { label: t('assetSchema.vinyl'), value: 'Vinyl' },
          { label: t('assetSchema.stucco'), value: 'Stucco' },
          { label: t('assetSchema.metal'), value: 'Metal' },
          { label: t('assetSchema.pvc'), value: 'PVC' },
          { label: t('assetSchema.tile_type'), value: 'Tile' },
          { label: t('assetSchema.brick'), value: 'Brick' },
          { label: t('assetSchema.fiber_reinforced_plastic'), value: 'Fiber Reinforced Plastic' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.open_stud'), value: 'Open Stud' },
          { label: t('assetSchema.inconclusive'), value: 'Inconclusive' },
          { label: t('assetSchema.inaccessible'), value: 'Inaccessible' }
        ],
        enabled: false,
        required: false,
        visible: false
      },
      exterior_door_count: {
        label: t('assetSchema.headers.exterior_door_count'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false
      },
      exterior_door_dimensions: {
        label: t('assetSchema.headers.exterior_door_dimensions'),
        type: 'select',
        isMulti: true,
        enabled: false,
        required: false,
        visible: false,
        options: [
          { label: `3'0" W x 7'0" H`, value: `3'0" W x 7'0" H` },
          { label: `3'0" W x 6'0" H`, value: `3'0" W x 6'0" H` },
          { label: `3'0" W x 6'11" H`, value: `3'0" W x 6'11" H` },
          { label: `2'8" W x 6'11" H`, value: `2'8" W x 6'11" H` },
          { label: `2'8" W x 7'0" H`, value: `2'8" W x 7'0" H` },
          { label: `2'11" W x 6'0" H`, value: `2'11" W x 6'0" H` },
          { label: `2'11" W x 7'0" H`, value: `2'11" W x 7'0" H` },
          { label: `2'11" W x 6'11" H`, value: `2'11" W x 6'11" H` },
          { label: `3'6" W x 7'0" H`, value: `3'6" W x 7'0" H` },
          { label: `3'6" W x 8'0" H`, value: `3'6" W x 8'0" H` },
          { label: `3'10" W x 7'0" H`, value: `3'10" W x 7'0" H` },
          { label: `3'11" W x 7'0" H`, value: `3'11" W x 7'0" H` },
          { label: `3'10" W x 6'11" H`, value: `3'10" W x 6'11" H` },
          { label: `3'11" W x 6'11" H`, value: `3'11" W x 6'11" H` },
          { label: `3'10" W x 6'10" H`, value: `3'10" W x 6'10" H` },
          { label: `3'11" W x 6'10" H`, value: `3'11" W x 6'10" H` },
          { label: `3'0" W x 8'0" H`, value: `3'0" W x 8'0" H` },
          { label: `4'0" W x 7'0" H`, value: `4'0" W x 7'0" H` },
          { label: `4'0" W x 6'11" H`, value: `4'0" W x 6'11" H` },
          { label: `4'0" W x 6'10" H`, value: `4'0" W x 6'10" H` },
          { label: `4'0" W x 8'0" H`, value: `4'0" W x 8'0" H` },
          { label: `4'11" W x 7'0" H`, value: `4'11" W x 7'0" H` },
          { label: `4'11" W x 8'0" H`, value: `4'11" W x 8'0" H` },
          { label: `5'0" W x 7'0" H`, value: `5'0" W x 7'0" H` },
          { label: `5'0" W x 8'0" H`, value: `5'0" W x 8'0" H` },
          { label: `5'0" W x 6'11" H`, value: `5'0" W x 6'11" H` },
          { label: `5'0" W x 7'11" H`, value: `5'0" W x 7'11" H` },
          { label: `5'11" W x 7'0" H`, value: `5'11" W x 7'0" H` },
          { label: `5'11" W x 8'0" H`, value: `5'11" W x 8'0" H` },
          { label: `6'0" W x 7'0" H`, value: `6'0" W x 7'0" H` },
          { label: `6'0" W x 8'0" H`, value: `6'0" W x 8'0" H` },
          { label: `6'0" W x 6'11" H`, value: `6'0" W x 6'11" H` },
          { label: `6'0" W x 7'11" H`, value: `6'0" W x 7'11" H` },
          { label: t('term.other'), value: `Other` }
        ]
      },
      light_fixture_count: {
        label: t('assetSchema.headers.light_fixture_count'),
        placeholder: '0',
        type: 'number',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      type_of_fixture: {
        label: t('assetSchema.headers.type_of_fixture'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.options.encased'), value: 'Encased' },
          { label: t('assetSchema.options.suspended'), value: 'Suspended' },
          { label: t('assetSchema.options.recessed'), value: 'Recessed' },
          { label: t('assetSchema.options.flush_mount'), value: 'Flush Mount' },
          { label: t('assetSchema.options.track'), value: 'Track' },
          { label: t('assetSchema.options.sconce'), value: 'Sconce' },
          { label: t('assetSchema.options.strip'), value: 'Strip' },
          { label: t('assetSchema.options.NA'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        photosEnabled: false,
        required: false
      },
      type_of_lighting: {
        label: t('assetSchema.headers.type_of_lighting'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.options.flourescent'), value: 'Flourescent' },
          { label: t('assetSchema.options.led'), value: 'LED' },
          { label: t('assetSchema.options.halogen'), value: 'Halogen' },
          { label: t('assetSchema.options.metal_hallide'), value: 'Metal Hallide' },
          { label: t('assetSchema.options.hps'), value: 'HPS (Hight Pressure Sodium)' },
          { label: t('assetSchema.options.incandescent'), value: 'Incandescent' },
          { label: t('assetSchema.options.NA'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        photosEnabled: false,
        required: false
      },
      hydraulic_sprinkler: {
        label: t('assetSchema.hydraulic_sprinkler.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      access_interior_area: {
        label: t('assetSchema.access_interior_area.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          options: { fullLength: true }
        }
      },
      floor_drain_count: {
        label: t('assetSchema.floor_drain_count.label'),
        placeholder: '0',
        type: 'number',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      floor_drain_location: {
        label: t('assetSchema.floor_drain_location.label'),
        placeholder: '',
        type: 'select',
        isMulti: true,
        options: id360LocationOptions,
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_transformer: {
        label: t('assetSchema.exterior_transformer.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      meter_room_space: {
        label: t('assetSchema.meter_room_space.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_access_rooms: {
        label: t('assetSchema.exterior_access_rooms.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_partition_extrusion: {
        label: t('assetSchema.exterior_partition_extrusion.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_door_locations: {
        label: t('assetSchema.headers.exterior_door_locations'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.front'), value: 'Front' },
          { label: t('assetSchema.left_side'), value: 'Left Side' },
          { label: t('assetSchema.right_side'), value: 'Right Side' },
          { label: t('assetSchema.rear'), value: 'Rear' },
          { label: t('assetSchema.all_sides'), value: 'All Sides' }
        ],
        enabled: false,
        required: false,
        visible: false
      }
    },
    ceiling_information: {
      label: t('assetSchema.headers.ceiling_information'),
      number_of_acoustical_tiles: {
        label: t('assetSchema.number_of_acoustical_tiles'),
        placeholder: '42',
        type: 'number',
        required: false,
        enabled: false,
        visible: false
      }
    },
    storefront_slope_measurement: {
      label: t('assetSchema.storefront_slope_measurement.label'),
      placeholder: t('assetSchema.storefront_slope_measurement.placeholder'),
      type: "measurement",
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    storefront_slope_direction: {
      label: t('assetSchema.storefront_slope_direction.label'),
      placeholder: t('assetSchema.storefront_slope_direction.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: 'Left', value: 'Left' },
        { label: 'Right', value: 'Right' },
        { label: 'NA', value: 'NA' }
      ],
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    hazardous_materials: {
      label: t('assetSchema.hazardous_materials.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      width: '100%'
    },
    changes_in_demising_wall_thickness: {
      label: t('assetSchema.changes_in_demising_wall_thickness.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    which_demising_wall_changes: {
      label: t('assetSchema.which_demising_wall_changes.label'),
      placeholder: t('assetSchema.which_demising_wall_changes.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: 'Left', value: 'Left' },
        { label: 'Right', value: 'Right' },
        { label: 'Front', value: 'Front' },
        { label: 'Rear', value: 'Rear' },
        { label: 'NA', value: 'NA' }
      ],
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    difference_demising_wall_thickness: {
      label: t('assetSchema.difference_demising_wall_thickness.label'),
      placeholder: t('assetSchema.difference_demising_wall_thickness.placeholder'),
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    riser_room_scanned_captured: {
      label: t('assetSchema.riser_room_scanned_captured.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    exterior_wall_photograph: {
      label: t('assetSchema.exterior_wall_photograph.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    storefront_scan_width: {
      label: t('assetSchema.storefront_scan_width.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_capture_hvac: {
      label: t('assetSchema.roof_capture_hvac.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_plan_complete: {
      label: t('assetSchema.roof_plan_complete.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    projector_photograph: {
      label: t('assetSchema.projector_photograph.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    window_pane_type: {
      label: t('assetSchema.window_pane_type.label'),
      placeholder: t('assetSchema.window_pane_type.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: t('assetSchema.single_pane'), value: 'Single Pane' },
        { label: t('assetSchema.double_pane'), value: 'Double Pane' },
        { label: t('assetSchema.triple_pane'), value: 'Triple Pane' },
        { label: 'NA', value: 'NA' }
      ],
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    loading_dock: {
      label: t('assetSchema.loading_dock.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false
    }
  }
}